export default "__VITE_PUBLIC_ASSET__1aa44f7f__"